import { observer } from 'mobx-react';
import { TODO } from 'utils/Types';

// Constants
import { Divider } from './styles';

function MiniDivider({ classes, style }: { classes: TODO; style: TODO }) {
  return <Divider className={classes} style={style} />;
}

export default observer(MiniDivider);
